import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import { convertContentStackAsset, KEY_CODES } from "../../utils"

const LinkDropdownWrapper = ({ data }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const anchoredDropdown = useRef(null);
  const anchoredTitle = useRef(null);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const handleClickOutside = (e) => {
    if (anchoredDropdown.current && anchoredTitle.current && !anchoredTitle.current.contains(e.target)) {
      setIsCollapsed(true);
    }
  };

  return (
    <div className="primary_link_container primary_link_container--dropdown">
      <img
        src={convertContentStackAsset(data.image.url)}
        className="primary_link_container__image"
      ></img>
      <div
        className={cx('link-wrapper')}
        ref={anchoredTitle}
        tabIndex="0"
        role="listbox"
        onKeyDown={(e) => {
          const event = e.nativeEvent;
          event.stopPropagation();

          if (event.code === KEY_CODES.SPACE || event.code === KEY_CODES.RETURN) {
            setIsCollapsed(!isCollapsed);
          }
        }}
        onClick={() => {
          setIsCollapsed(!isCollapsed);
        }}
      >
        <p className="menu_link">{data.item_url.title}</p>
        <div className={cx('arrow_icon', { pointing_down: isCollapsed })}></div>
      </div>
      <div
        ref={anchoredDropdown}
        className={cx('sub_link_container', { collapsed: isCollapsed })}
      >
        {data.sub_items.map((sub_item, subItemIdx) => {
          return (
            <a
              key={subItemIdx}
              className="menu_link menu_link--sub-item"
              href={sub_item.sub_item.sub_item.href}
            >
              {sub_item.sub_item.sub_item.title}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default LinkDropdownWrapper;
